<template>
  <DropDownMenu
    :classNames="classNames"
    :closeOnItemClick="closeOnItemClick"
    :handleClickaway="handleClickaway"
    :isFilterDropDown="true"
    :isLargeDropDown="false"
    :menuSections="menuSections"
    menuFontSize="small"
    menuTitle="filter by"
    :refresh="refresh"
    :showMenuLabel="true"
    :storeModule="storeModule"
  />
</template>

<script>
import { extend } from 'lodash';
import { mapActions } from 'vuex';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';
import DropDownMenu from 'client/components/DropDownMenu/DropDownMenu.vue';

export default {
  name: 'DropDownFilter',

  components: {
    DropDownMenu,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  props: {
    closeOnItemClick: {
      default: false,
      type: Boolean,
    },

    menuSections: {
      type: Array,
      required: true,
    },

    storeModule: {
      type: String,
      required: true,
    },
  },

  data() {
    const classNames = {
      container: 'filterBarContainer',
      dropDownList: 'filterBarDropDownList',
    };
    return {
      classNames,
      // Keep filter drop down open until clicking outside the list
      handleClickaway: () => {},
    };
  },

  beforeCreate() {
    extend(
      this.$options.methods,
      mapActions(this.$options.propsData.storeModule, [
        'fetchCollection',
      ]),
    );
  },
};
</script>
